export const REFUND_TYPES = ['Full', 'Partial'];
